import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Register Service Worker for PWA installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const hadController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker
      ?.register('/sw.js', { updateViaCache: 'none' })
      ?.then((reg) => {
        reg.update();
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') reg.update();
        });
      })
      ?.catch(() => {
        // SW registration failed silently
      });

    if (hadController) {
      let refreshed = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshed) return;
        refreshed = true;
        window.location.reload();
      });
    }
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
